import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { Response } from '../interfaces/response.interface';
import { map } from 'rxjs/operators';
import { Role } from '../+state/roles/interfaces/role.interface';
import { ApiUrlService } from './api-url.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private _url = `${this._apiService.apiUrl}/access/roles`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public getRoles(): Observable<Role[]> {
    return this._http.get<Response<Role[]>>(this._url)
      .pipe(
        map(response => response?.data),
        shareReplay(),
      );
  }

  public getRole(roleId: string): Observable<Role> {
    return this._http.get<Response<Role>>(`${this._url}/${roleId}`)
      .pipe(
        map(response => response?.data),
        shareReplay(),
      );
  }

  public addRole(roleName: string, scopes: string[]): Observable<Role> {
    const role = {
      id: roleName.toLowerCase().trim().replace(/\s/g, '_'),
      name: roleName,
      scopes,
    }
    return this._http.post<Response<Role>>(this._url, role)
      .pipe(
        map(response => response?.data),
      );
  }

  public updateRole(roleId: string, scopes: string[]): Observable<Role> {
    const url = `${this._url}/${roleId}`;
    return this._http.patch<Response<Role>>(url, { scopes })
      .pipe(
        map(response => response?.data),
      );
  }

  public removeRole(roleId: string): Observable<unknown> {
    const url = `${this._url}/${roleId}`;
    return this._http.delete<unknown>(url);
  }
}
